import React from 'react'
import { IconButton } from '@mui/material'
import { UsersIcon } from '@heroicons/react/24/outline'
import { OrgRole, type OrgMemberRow } from 'pure-js/types/OrganizationMembership'

import { TESTIDS } from '../../../../config/testids'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { ORG_TABLE_ROW_ACTION_ICON_SIZE_PX, orgTableRowActionSx } from '../../components/orgTableStyles'

export type OrgMemberManagePeopleActionProps = {
  member: OrgMemberRow
  /** Left out where the people of a leader cannot be managed, and then nothing is rendered. */
  onManagePeople?: (member: OrgMemberRow) => void
}

/** The action of a leader row that opens the people they lead; every other row renders nothing here. */
export const OrgMemberManagePeopleAction: React.FC<OrgMemberManagePeopleActionProps> = ({ member, onManagePeople }) => {
  const { t } = useTranslation()
  const isShown = !!onManagePeople && member.role === OrgRole.LEADER
  if (!isShown) return null

  return (
    <IconButton
      size="small"
      onClick={() => onManagePeople?.(member)}
      aria-label={t('org.members.managePeople')}
      data-testid={TESTIDS.ORG_MEMBER_MANAGE_PEOPLE_BTN}
      sx={orgTableRowActionSx}
    >
      <UsersIcon width={ORG_TABLE_ROW_ACTION_ICON_SIZE_PX} height={ORG_TABLE_ROW_ACTION_ICON_SIZE_PX} />
    </IconButton>
  )
}
